// utils/analytics-config.ts
// Google Analytics configuration utilities

export const getAnalyticsId = (): string | null => {
  // Check environment variable first
  const envId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
  
  if (envId && envId !== 'G-XXXXXXXXXX') {
    return envId;
  }
  
  // Fallback for development
  console.warn('Google Analytics ID not configured. Set VITE_GOOGLE_ANALYTICS_ID in your .env file');
  return null;
};

export const isAnalyticsEnabled = (): boolean => {
  const id = getAnalyticsId();
  return id !== null && id !== 'G-XXXXXXXXXX';
};
